document.addEventListener('DOMContentLoaded', function () {

    $('body').on('click', '.black-friday', function (e) {
        e.stopPropagation();
    });

    $('body').on('click', '.black-friday .close', function (e) {
        $('.black-friday__wrapper').removeClass('__open');
    });

    $('body').on('click', '.black-friday__wrapper', function (e) {
        $('.black-friday__wrapper').removeClass('__open');
    });
});

function showBlackFridayPopUp() {
    $('.black-friday__wrapper').addClass('__open');
}

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(showBlackFridayPopUp, 8000);
});